module.exports = __webpack_public_path__ + "static/img/map.763f5b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/map.jpg
// module id = whad
// module chunks = 0